// eslint-disable-next-line import/no-cycle
import ForgotPasswordForm from 'profile/login/forms/ForgotPasswordFormNoRoutes';

const ReturningCustomer = (props) => {
  const { onLogin, redirectLink } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <ForgotPasswordForm onLogin={onLogin} redirectLink={redirectLink} />
    </div>
  );
};

export default ReturningCustomer;
